/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_AromasInputs */

const en_search_aromas = /** @type {(inputs: Search_AromasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search aromas...`)
};

const es_search_aromas = /** @type {(inputs: Search_AromasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar aromas...`)
};

/**
* | output |
* | --- |
* | "Search aromas..." |
*
* @param {Search_AromasInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const search_aromas = /** @type {((inputs?: Search_AromasInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_AromasInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_search_aromas(inputs)
	return es_search_aromas(inputs)
});